import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { Skeleton } from "@fronterahealth/frontera-ui-components/ui/skeleton";

export const ReportFieldSkeleton: React.FC<{
  className?: string;
  classNameTitle?: string;
  classNameField?: string;
}> = ({ className, classNameField, classNameTitle }) => {
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      <Skeleton className={cn("h-4 w-20 bg-input", classNameTitle)} />
      <Skeleton className={cn("h-28 w-full bg-input", classNameField)} />
    </div>
  );
};
